export const isSingleItemPerDeliveryEnabled = (
  erpType?: string | null,
): boolean => {
  return erpType === 'VAS';
};
